import React from "react";

function SecondaryCriteriaIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 115.98 80.83">
      <rect x="0" width="69.98" height="13.71" rx="4.96" ry="4.96" />
      <rect y="22.69" width="69.98" height="13.71" rx="4.96" ry="4.96" />
      <rect y="45.39" width="48.46" height="13.71" rx="4.96" ry="4.96" />
      <path d="M111.02,45.07h-17.1v-17.1c0-2.74-2.22-4.96-4.96-4.96h-3.79c-2.74,0-4.96,2.22-4.96,4.96v17.1h-17.1c-2.74,0-4.96,2.22-4.96,4.96v3.79c0,2.74,2.22,4.96,4.96,4.96h17.1v17.1c0,2.74,2.22,4.96,4.96,4.96h3.79c2.74,0,4.96-2.22,4.96-4.96v-17.1h17.1c2.74,0,4.96-2.22,4.96-4.96v-3.79c0-2.74-2.22-4.96-4.96-4.96Z" />
    </svg>
  );
}

export { SecondaryCriteriaIcon };
